<!-- Footer -->
<footer class="text-center fs-6 fw-lighter bg-transparent text-muted">
  <span class="version">v.{{ version }}</span>
</footer>
<!-- Footer -->
